import { getRequest } from '../services/requestHandler';
import { BuildLocationsForDropdown } from '../models';

// Model: TourApp.Data/Models/PlayerRegionLookup
export const getBuildLocationsForDropdown = async () => {
  const url = 'orderlookup/getBuildLocationsForDropdown?activeOnly=true';
  const response = await getRequest<BuildLocationsForDropdown>('GetBuildLocationsForDropdown', url);
  return response;
};
